export function formatCurrency(currency, value) {
    return value != null && currency != null ? getCurrencyFormatter(currency).format(value) : "-";
}

export function getCurrencyFormatter(currency) {
    if (currency.length == 3) {
        return new Intl.NumberFormat(navigator.language, {
            style: "currency",
            currency,
        });
    } else {
        return new Intl.NumberFormat(navigator.language, {
            style: "currency",
            currency: "EUR",
        });
    }
}

export function getObjPropFromString(obj, prop) {
    if (obj) {
        let value = obj;
        if (prop.includes(".")) value = this.getObjPropFromString(value[prop.substr(0, prop.indexOf("."))], prop.substr(prop.indexOf(".") + 1));
        else value = value[prop];
        return value;
    } else return null;
}

export function formatBytes(bytes, si = true, dp = 1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + " B";
    }

    const units = si ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

    return parseFloat(bytes.toFixed(dp)) + " " + units[u];
}

export function formatSeconds(secondsInput, short, forceSeconds) {
    let temp = secondsInput;
    temp %= 86400;
    let hours = Math.floor(temp / 3600);
    let toReturn = "";

    if (hours) {
        let hourString = short ? "h" : this.$tc("security_management.hour", hours);
        toReturn += short ? `${hours}${hourString} ` : `${hours} ${hourString} `;
    }
    temp %= 3600;
    let minutes = Math.floor(temp / 60);
    if (minutes) {
        let minuteString = short ? "m" : this.$tc("security_management.minute", minutes);
        toReturn += short ? `${minutes}${minuteString} ` : `${minutes} ${minuteString} `;
    }
    if (!short || temp < 60 || forceSeconds) {
        let seconds = Math.floor(temp % 60);
        if (seconds) {
            let secondString = short ? "s" : this.$tc("security_management.second", seconds);
            toReturn += short ? `${seconds}${secondString} ` : `${seconds} ${secondString} `;
        }
    }
    return toReturn == "" ? "0" : toReturn;
}

export function formatMilliseconds(secondsInput) {
    let temp = secondsInput;

    temp %= 86400000;
    let hours = Math.floor(temp / 3600000);
    let toReturn = "";

    if (hours) toReturn += `${hours}h `;

    temp %= 3600000;
    let minutes = Math.floor(temp / 60000);
    if (minutes) toReturn += `${minutes}m `;

    let seconds = Math.floor(temp / 1000);
    if (seconds) toReturn += `${seconds}s `;

    let milliseconds = Math.floor(temp % 1000);
    if (milliseconds) toReturn += `${milliseconds}ms `;

    return toReturn == "" ? "0" : toReturn;
}

export function prettyXml(sourceXml) {
    try {
        let xmlDoc = new DOMParser().parseFromString(sourceXml, "application/xml");
        let xsltDoc = new DOMParser().parseFromString(
            [
                '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform" version="1.0">',
                '  <xsl:strip-space elements="*"/>',
                '  <xsl:template match="para[content-style][not(text())]">',
                '    <xsl:value-of select="normalize-space(.)"/>',
                "  </xsl:template>",
                '  <xsl:template match="node()|@*">',
                '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
                "  </xsl:template>",
                '  <xsl:output indent="yes" version="1.0" encoding="UTF-8" />',
                "</xsl:stylesheet>",
            ].join("\n"),
            "application/xml"
        );
        let xsltProcessor = new XSLTProcessor();
        xsltProcessor.importStylesheet(xsltDoc);
        let resultDoc = xsltProcessor.transformToDocument(xmlDoc);
        let resultXml = new XMLSerializer().serializeToString(resultDoc);
        if (!resultXml.includes("<?xml")) resultXml = '<?xml version="1.0" encoding="utf-8"?>\n' + resultXml;
        return resultXml;
    } catch (e) {
        return sourceXml;
    }
}
